import { createSelector } from 'reselect';
import { RootState } from '../../../types';

const session = (state: RootState) => state.session;

export const selectSession = createSelector([session], session => {
  return session;
});
